import { z } from 'zod';
import { BaseIntegration } from 'libs/end-to-end/src/types/databases/integrations/base-integration';
import { SecretReference } from 'libs/end-to-end/src/types/secrets/secret-reference';

export const PostgresIntegrationTable = z.object({
  tableName: z.string(),
  schema: z.string().optional(),
});

export type PostgresIntegrationTable = z.infer<typeof PostgresIntegrationTable>;

export const PostgresIntegration = BaseIntegration.extend({
  integrationType: z.literal('Postgres'),
  host: z.string(),
  port: z.number(),
  database: z.string(),
  user: z.string(),
  ssl: z.boolean(),
  retryCount: z.number(),
  passwordReference: SecretReference.optional(),
  tables: PostgresIntegrationTable.array(),
});

export type PostgresIntegration = z.infer<typeof PostgresIntegration>;
